import { render, staticRenderFns } from "./MovementListItem.vue?vue&type=template&id=622aac30&scoped=true&"
import script from "./MovementListItem.vue?vue&type=script&lang=js&"
export * from "./MovementListItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "622aac30",
  null
  
)

export default component.exports